import { DeepReadonlyObject } from 'rxdb';

import { Booking, DataChange } from '@mopla/data-models';
import { isBookingStatusCancelled } from '@mopla/utils';

export function mergeBookingsWithChanges(
	bookings: DeepReadonlyObject<Booking>[],
	dataChanges: DeepReadonlyObject<DataChange>[]
): Booking[] {
	const updatedBookings = bookings.map((b) => {
		const currentBookingChange = dataChanges
			.filter((ch) => ch.bookingId === b.bookingId)
			.sort((a, b) => b.insertTime - a.insertTime)[0];

		if (!currentBookingChange) {
			return b;
		}

		const newBookingStatus = currentBookingChange.type;
		let newCheckedInState = b.checkedInScheduledLegs;
		const bookingCheckedInChange = currentBookingChange.checkedInLegs;
		const newCancellation: Partial<Booking> = {};

		/** A booking can be either canceled or checked in */
		if (currentBookingChange.options?.cancellationReason) {
			newCancellation.cancellationReason =
				currentBookingChange.options.cancellationReason;
			newCancellation.cancellationDescription =
				currentBookingChange.options.cancellationDescription;
		} else if (bookingCheckedInChange) {
			newCheckedInState = b.checkedInScheduledLegs.map((data) => {
				if (bookingCheckedInChange.includes(data.scheduledLegId)) {
					return {
						...data,
						isCheckedIn: true,
					};
				}
				return data;
			});
		}

		const newBooking = {
			...b,
			...newCancellation,
			checkedInScheduledLegs: newCheckedInState,
			bookingState: newBookingStatus,
		};

		/** Remove cancellation fields if the booking is not cancelled */
		if (!isBookingStatusCancelled(newBookingStatus)) {
			delete newBooking.cancellationReason;
			delete newBooking.cancellationDescription;
		}

		return newBooking;
	});

	/** DeepReadonlyObject works only in the types layer, thus can be safely casted to a regular (mutable) type */
	return updatedBookings as Booking[];
}
